import React from 'react';
import { useTranslation } from 'react-i18next';
import Card from 'shared/components/Card/Card';
import { DownloadIcon } from 'shared/components/icons/DownloadIcon';
import { CardDescription, CardDescriptionBold } from 'shared/components/Card/Card.styles';
import PopUpErrorModal from 'shared/components/PopUpErrorModal/PopUpErrorModal';
import { CardBody } from '../SystemDetails.styles';

export interface ContractCardProps {
  contractType: string;
  contractSignedDate?: string;
  contractTerm: number;
  onClick: () => void;
  downloadErrorModal: boolean;
  setDownloadErrorModal: (value: boolean) => void;
}

export function ContractCard({
  contractType,
  contractSignedDate,
  contractTerm,
  onClick,
  downloadErrorModal,
  setDownloadErrorModal,
}: ContractCardProps) {
  const { t } = useTranslation();
  const handleCloseModal = () => setDownloadErrorModal(false);
  const handleRefresh = () => window.location.reload();

  return (
    <>
      <Card
        title={contractType}
        actionText={t('status.downloadContract')}
        actionIcon={{ element: <DownloadIcon /> }}
        onClick={onClick}
      >
        <CardBody>
          {contractSignedDate && (
            <>
              <CardDescription as="body">{t('status.contractSigned')}</CardDescription>
              <CardDescriptionBold as="body">{contractSignedDate}</CardDescriptionBold>
            </>
          )}
          <CardDescription as="body">{t('status.contractTerm')}</CardDescription>
          <CardDescriptionBold as="body">
            {contractTerm} {contractTerm === 1 ? t('status.year') : t('status.years')}
          </CardDescriptionBold>
        </CardBody>
      </Card>
      <PopUpErrorModal
        openModal={downloadErrorModal}
        onCloseModal={handleCloseModal}
        onRefresh={handleRefresh}
      />
    </>
  );
}

export default ContractCard;
